import type { Epic } from 'epics/rxjs';
import { Observable } from 'epics/rxjs';

import type {
    FetchServiceProjectRequestPermissionFailure,
    FetchServiceProjectRequestPermission,
    FetchServiceProjectRequestPermissionSuccess,
} from 'state/actions/user';

import {
    FETCH_SERVICE_PROJECT_REQUEST_PERMISSIONS,
    fetchServiceProjectRequestPermissionSuccess,
    fetchServiceProjectRequestPermissionFailure,
} from 'state/actions/user';

import { serviceProjectRequestPermissions } from 'rest/service-project-request-permissions';
import type { ServiceProjectRequestPermissionsResponseType } from 'rest/service-project-request-permissions/service-project-request-permissions';

export const fetchServiceProjectPermissionsEpic: Epic<
    FetchServiceProjectRequestPermission,
    FetchServiceProjectRequestPermissionSuccess | FetchServiceProjectRequestPermissionFailure
> = (action$) => {
    return action$.ofType(FETCH_SERVICE_PROJECT_REQUEST_PERMISSIONS).mergeMap(() => {
        return serviceProjectRequestPermissions()
            .map((response: ServiceProjectRequestPermissionsResponseType) => {
                const { isEnabled, canCreateProject } = response;
                return fetchServiceProjectRequestPermissionSuccess(isEnabled, canCreateProject);
            })
            .catch(() => {
                return Observable.of(fetchServiceProjectRequestPermissionFailure());
            });
    });
};
